import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'

import { AssetAdminWithState } from './pages/assets-with-state'

export const AssetAdmin = () => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={<AssetAdminWithState />}
    topBarElement={<UserMenuTopBar />}
  />
)
